module.exports = __webpack_public_path__ + "static/media/DSC01727.c3b67652.jpg";